import './LoadingSpinner.scss'

const LoadingSpinner = () => {
  return <div className="spinner"></div>;
}

export default LoadingSpinner;
